export enum Sector {
  None = 0,
  FinancialInstitute = 1,
  ExpertOffice = 2,
  ReaLEstate = 3,
  FinancingBroker = 4,
  Investor = 5,
  Others = 6
}
